module.exports = __webpack_public_path__ + "static/media/huibert_van_dorp.1a5106d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huibert_van_dorp.jpg
// module id = 306
// module chunks = 0